import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';


const AfficheReservation = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheReservationAnalitic/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}



export {AfficheReservation}